import lodash from "lodash";
export const downloadjs = require("downloadjs");

// 获取当前运行的环境是pc, mobile
export function getCurrentEnvironment() {
    const result = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
    );

    return result ? "phone" : "pc";
}

/**
 * 时间戳格式化
 * @param  {[longnumber]} timestamp 要格式化的时间戳
 * @param  {[boolean]} toSecond  是否格式化到秒 否则格式化到毫秒
 * @return {[longnumber]}  返回格式化成功后的时间戳
 */
export function renderTimestamp(timestamp, toSecond) {
    if (!timestamp || typeof timestamp !== "number") return timestamp;
    let len = timestamp.toString().length;
    if (toSecond && len === 13) {
        return Math.floor(timestamp / 1000);
    }
    if (!toSecond && len === 10) {
        return timestamp * 1000;
    }
    return timestamp;
}

/**
 * 获取时间对象
 * @param  {[longnumber]} time 时间戳
 * @return {[Date]} 返回时间对象
 */
export function newDate(time) {
    time = renderTimestamp(time);
    if (!time) return new Date();
    return new Date(time);
}

/**
 * 时间格式化
 * @param  {[number]} time 要格式化的时间戳，到毫秒
 * @param  {[string]} fmt  要格式化成的形式，默认 yyyy-MM-dd hh:mm:ss
 * @return {[string]}      返回格式化成功后的字符串
 */
export function formatDate(time, fmt) {
    if (!time || isNaN(time)) return "--";
    let date = newDate(time);
    fmt = fmt || "yyyy-MM-dd hh:mm:ss";

    if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(
            RegExp.$1,
            (date.getFullYear() + "").substr(4 - RegExp.$1.length)
        );
    }
    let o = {
        "M+": date.getMonth() + 1,
        "d+": date.getDate(),
        "h+": date.getHours(),
        "m+": date.getMinutes(),
        "s+": date.getSeconds()
    };
    for (let k in o) {
        if (new RegExp(`(${k})`).test(fmt)) {
            let str = o[k] + "";
            fmt = fmt.replace(
                RegExp.$1,
                RegExp.$1.length === 1 ? str : ("00" + str).substr(str.length)
            );
        }
    }
    return fmt;
}

/**
 * 时间格式化
 * @param  {[number]} timeStr 要格式化的时间字符串 ex: 20170808
 * @return {[string]}      返回格式化成功后的字符串
 */
export function formatDateStr(timeStr) {
    if (!timeStr) return '--'
    let re = /^(\d{4})(\d{2})?(\d{2})$/
    return timeStr.replace(re, '$1-$2-$3').replace('--', '-')
}

/**
 * 将json 序列化，只支持简单对象的序列化，不支持深层序列化
 * @param  {[json]} obj 要序列化的json
 * @return {[string]}   序列化成功后的字符串
 */
export function queryString(obj) {
    if (!obj || typeof obj !== 'object') return ''
    let params = []
    for (let i in obj) {
        params.push(i + '=' + obj[i])
    }
    return params.join('&')
}

export function isFun(fn) {
    return lodash.isFunction(fn);
}

export function isEmpty(data) {
    return lodash.isFunction(data);
}

export function debounce(func, time) {
    return lodash.debounce(func, time);
}

export function filterPermission(menulist, permission) {
    let arr = [];
    if (permission.indexOf("*") > -1) {
        return menulist;
    }
    menulist.forEach(menu => {
        if (menu.permissionName === undefined) {
            arr.push(menu);
        } else if (permission.indexOf(menu.permissionName) > -1) {
            arr.push(menu);
        }
    });
    return arr;
}
